import { QRCode } from 'antd';
import styled from 'styled-components';

export default styled(QRCode)`
	// Add your styles here
`;
